import { LedgerActivityReportLedgerType } from '@mews-commander/data-access';
import { CardContainer } from '@mews/b2b-ui';
import { Stack, Typography } from '@optimus-web/core';
import { LocalizedCurrency } from '@mews/framework';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useLedgerActivityReportQuery } from '../hooks/useLedgerActivityReportQuery';
import { LedgerActivityReportFilterValues } from '../schema';

interface LedgerActivityReportHighlightCardProps {
    ledgerType: LedgerActivityReportLedgerType;
    title: React.ReactNode;
    totalCardTitle?: React.ReactNode;
    filterValues: LedgerActivityReportFilterValues;
}
export const LedgerActivityReportHighlightCard = ({
    ledgerType,
    title,
    totalCardTitle,
    filterValues,
}: LedgerActivityReportHighlightCardProps) => {
    const {
        data: { ledgerTotal },
    } = useLedgerActivityReportQuery({
        ledgerType,
        filterValues,
    });

    const { defaultCurrencyCode } = useCurrentEnterprise();
    return (
        <CardContainer data-test-id="ledger-activity-card">
            <Stack spacing="100" vertical>
                <Typography data-test-id="title" textStyle="bodyLargeStrong" as="div">
                    {totalCardTitle ?? title}
                </Typography>
                <Typography textStyle="highlightMedium" as="div">
                    <LocalizedCurrency currency={defaultCurrencyCode} value={ledgerTotal} />
                </Typography>
            </Stack>
        </CardContainer>
    );
};
